<template>
    <div id="open-button" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="goBackward">Назад</div>
    </div>
</template>

<script>
    export default {
        name: "RightLowerBarBack",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            adjacentSteps() {
                let stepsOrder = this.$store.state.UI.stepsChain[this.version].stepsOrder
                return stepsOrder[this.activeStep]
            }
        },
        methods: {
            goBackward() {
                this.$router.push({name: this.adjacentSteps.prev}).catch(err=>{})
            }
        }
    }
</script>

<style scoped>

</style>
